import React from 'react';
import { Divider } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { Heading } from '../../../../../styleguide';
import { useTheme } from '../../../../../hooks';
import { SPACING } from '../../../../../styles/constants';

import {
  StepContentWrapper,
  ItemsWrapper,
  DetailsWrapper,
} from '../../../../../styles/order-tracking';
import DeliveredIllustration from '../../../../../assets/images/orders/Done.svg';
import ProductLine from '../../../../basket/ProductLine';
import MenuLine from '../../../../basket/MenuLine';
import {
  Totals,
  PaymentMethodRow,
  IllustrationHeader,
  Header,
  AddressesBlock,
  MessageBlock,
} from './Commons';
import DownloadReceiptButton from '../DownloadReceiptButton';

const DeliveredStep = props => {
  const { order } = props;
  const theme = useTheme();
  const { t } = useTranslation(['orders']);

  return (
    <StepContentWrapper>
      <IllustrationHeader imgSrc={DeliveredIllustration} />

      <Header
        order={order}
        customTitle={
          <Heading size={600}>
            {t('orders:tracking:your_order_at')}
            <span style={{ color: theme.primaryColor }}>{order.shop.name}</span>
            {t('orders:tracking:was_delivered')} {'😋'}
          </Heading>
        }
      />
      <Divider style={{ width: '100%', marginBottom: `${SPACING[400]}` }} />

      <ItemsWrapper>
        {order.itemsList.map((shopItem, index) =>
          shopItem.item.isMenu ? (
            <>
              <MenuLine key={index} shopItem={shopItem} small />
              {order.itemsList.length - 1 !== index && (
                <Divider style={{ width: '100%', margin: `${SPACING[100]}` }} />
              )}
            </>
          ) : (
            <>
              <ProductLine key={index} shopItem={shopItem} small />
              {order.itemsList.length - 1 !== index && (
                <Divider style={{ width: '100%', margin: `${SPACING[100]}` }} />
              )}
            </>
          )
        )}
      </ItemsWrapper>
      <Divider style={{ width: '100%', margin: `${SPACING[300]} 0` }} />

      <AddressesBlock order={order} />

      <DetailsWrapper>
        <PaymentMethodRow paymentMethod={order.paymentMethod} />
      </DetailsWrapper>
      <Divider style={{ width: '100%', marginTop: `${SPACING[300]}` }} />

      <MessageBlock order={order} />

      <Totals order={order} />
      <Divider style={{ width: '100%', margin: `${SPACING[100]}` }} />

      <DownloadReceiptButton order={order} />
    </StepContentWrapper>
  );
};

export default DeliveredStep;
